import { MyAccountToggleSaveButtonComponentPropsInterface } from 'common/module/my-account/toggle-save-button/component-props.interface';
import { MyAccountToggleSaveButtonTemplatePropsInterface } from 'common/module/my-account/toggle-save-button/template-props.interface';
import { MyAccountToggleSaveButtonViewStore } from 'common/module/my-account/toggle-save-button/view-store';
import { MyAccountToggleSaveButtonViewStoreFactory } from 'common/module/my-account/toggle-save-button/view-store.factory';
import { preactConnectStore } from 'common/module/preact/connect-store';
import { MyAccountToggleSaveButtonTemplate } from 'desktop/module/my-account/toggle-save-button/template';

export const MyAccountToggleSaveButtonComponent = preactConnectStore<
  MyAccountToggleSaveButtonViewStore,
  MyAccountToggleSaveButtonTemplatePropsInterface,
  MyAccountToggleSaveButtonComponentPropsInterface
>(
  MyAccountToggleSaveButtonViewStoreFactory,
  (store, { props }) => {
    store.updateState({
      id: props.property.id,
      property: props.property,
      isSmartad: props.isSmartad,
      isCts: props.isCts,
      statsContext: {
        property_save_cta: 'button',
      },
      className: props.className,
      theme: props.theme,
      isSaveMessageShownAfterPopup: props.isSaveMessageShownAfterPopup,
    });

    return store.getState();
  },
  (store, { props }) => {
    store.initialize({
      id: props.property.id,
      property: props.property,
      isSmartad: props.isSmartad,
      isCts: props.isCts,
      statsContext: {
        property_save_cta: 'button',
      },
      className: props.className,
      theme: props.theme,
      isSaveMessageShownAfterPopup: props.isSaveMessageShownAfterPopup,
    });
  }
)(MyAccountToggleSaveButtonTemplate);
